import { OrderedCaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import React from 'react';
import { useSelector } from 'react-redux';
import VoucherTypeSelect from './VoucherTypeSelect.js';
/** Searchable select for case voucher types, narrowable by category */
const CaseVoucherTypeSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(VoucherTypeSelect, { ...props, categories: props.categories ?? OrderedCaseVoucherCategories, placeholder: props.placeholder ?? lang.voucherTypeSelect.selectCaseVoucherType }));
};
export default CaseVoucherTypeSelect;
//# sourceMappingURL=CaseVoucherTypeSelect.js.map